/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

//import DataTable from 'react-data-table-component';
//import jQuery from 'jquery'; 
import Select from 'react-select'
//import Chosen from 'react-chosen';
import Spinner from 'components/Spinner.js';

const columns = [
    {
        //name: 'Item',
        selector: row => row.item,
        sortable: true,
    },
    {
        //name: 'Details',
        selector: row => row.detail,
    },
];

export default class StockCountJobItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showReasonCodes: false,
      reasonCodeSpinner: false,
      completeSpinner: false,
      newReasonCode: null,
      reasonCodes: [],
      data: []
    }
  }

  componentDidMount() {
    // this.state.socket.on('login', user => this.setState({ user, waitingForAuth: false }));
    // this.state.socket.on('error', err => this.setState({ user: null, waitingForAuth: false }));
    
    this.fetchStockJob();
    this.fetchReasonCodes();
  }

  fetchStockJob = () => {
    var $this = this;
    //alert($this.props.reference_code)
    fetch('/api/shared/stockCountJobs/lookup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        reference_code: $this.props.reference_code,
        //LOCNCODE: "WAREHOUSE"
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          // var stockCountJob = data.data.stockCountJob;
          // var tableData = [];
          // tableData.push({

          // })
          $this.setState({
            data: data.data.stockCountJob,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  fetchReasonCodes = () => {
    var $this = this;
    // Get reason codes
    fetch('/api/shared/transaction/reasonCodes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ transactionCode: "variance" })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          // var stockCountJob = data.data.stockCountJob;
          // var tableData = [];
          // tableData.push({

          // })
          $this.setState({
            reasonCodes: data.data.reasonCodes,
            showReasonCodes: true
          });
        }
        else {
          $this.setState({
            showReasonCodes: false
          });
          // alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showReasonCodes: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleRC = () =>
  {
    this.setState({reasonCodeSpinner: true})
    var $this = this;
    //alert($this.props.reference_code)
    fetch('/api/shared/stockCountJobs/setReasonCode', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        reference_code: $this.props.reference_code,
        Reason_Code: $this.state.newReasonCode
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          alert($this.props.reference_code + ' reason code updated!');
          //$this.props.reset();
          $this.setState({newReasonCode: null, reasonCodeSpinner: false}, () => $this.fetchStockJob());
        }
        else {
          $this.setState({
            completeSpinner: false, 
            reasonCodeSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false, 
          reasonCodeSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  onChange = e => {
    this.setState({newReasonCode: e.value});
    //alert(e.value);
  }

  handleComplete = () =>
  {
    if (!confirm(`Complete ${this.props.reference_code}?`))
      return;

    this.setState({completeSpinner: true});
    var $this = this;
    //alert($this.props.reference_code)
    fetch('/api/shared/stockCountJobs/complete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        reference_code: $this.props.reference_code,
        version: this.state.data.version
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          alert($this.props.reference_code + ' Completed!');
          $this.props.reset();
        }
        else {
          $this.setState({
            completeSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  render ()
  {
    return (
      <Fragment>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            MUI
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/material-ui/getting-started/installation/"
          >
            Core
          </Link>
          <Typography color="text.primary">Breadcrumbs</Typography>
        </Breadcrumbs> */}
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showTable ?
        <Fragment>
          <h3>{this.state.data.reference_code}</h3>
          { this.state.data.GP_STCKCNTID != null ?
          <Fragment>
            <h4>{this.state.data.GP_STCKCNTID}</h4>
            <h5>{this.state.data.GP_STCKCNTDSCRPTN}</h5>
          </Fragment>
          :null}
          <div>Reason code:{this.state.showReasonCodes ?
          <Select name="reasonCodes" defaultValue={{label:this.state.data.Reason_Code, value:this.state.data.Reason_Code}}
          onChange={this.onChange}
          options ={this.state.reasonCodes.map(e => 
            { return {
              value: e.Reason_Code,
              label: e.Reason_Code + ' (' + e.Reason_Code_Description + ')'
            };}
          ) }
          />
          :<Spinner/>}
          {
            this.state.reasonCodeSpinner ?
            <Spinner/>
            : this.state.newReasonCode != null? <Button variant="contained" color="primary" onClick={this.handleRC}>Update Reason Code</Button> 
            : null
          }
          <br/>
          <br/>
          <br/>
          {this.state.data.completed ?
          <Fragment>
            <Button variant="contained" color="primary" disabled>Completed</Button> <br/>
            <Button variant="contained" color="primary" onClick={() => window.open(`/pickingList/${this.state.data.reference_code}`, '_blank')}>Generate Picking List</Button>
          </Fragment>
          :
            this.state.completeSpinner ?
            <Spinner/> :
          <Button variant="contained" color="primary" onClick={this.handleComplete}>Complete Stock Count</Button>
          }
          </div>
        </Fragment>
        // <DataTable
        //       columns={columns}
        //       data={this.state.data}
        //       keyField='id'
        //       onRowClicked={r => this.props.setId(r.reference_code)}
        //       striped
        //       highlightOnHover
        //       pointerOnHover
        //       dense
        //       pagination
        //   />
        
          : ""
        }
      </Fragment>
    );
  }
}
